import { useCallback, useRef } from 'react';
import { useUnmount } from 'react-use';

export default function useDelayFn(fn: () => void, ms = 0) {
  const timeout = useRef<ReturnType<typeof setTimeout>>(null);
  const callback = useRef(fn);

  useUnmount(() => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
  });

  const call = useCallback(() => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    timeout.current = setTimeout(() => {
      callback.current?.();
    }, ms);
  }, [ms]);

  return call;
}
